import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import HeaderBanner from '../../images/event/cpd-header.png'
import QR from '../../images/event/qrcode.png'
import Amplitude from 'src/utils/amplitudeHelper'
import { SIZES } from 'src/styles/theme'

const StyledModal = styled(Modal)`
  .modal-content {
    width: 90%;
    margin: 0 auto;
    border: none;
    border-radius: 28px;
    background: #d7e0e8;
  }
  #banner {
    display: block;
    margin-top: -3.5em;
    margin-left: auto;
    margin-right: 0;
    width: 90%;
  }
  .modal-header {
    border: none;

    .close {
      color: #414141;
      opacity: 1;
      padding: 16px;
      margin-left: 0;
      font-size: 40px;
      font-weight: 400;
      text-shadow: none;
    }
  }
  .modal-body {
    width: 90%;
    margin: 0 auto;
    padding-top: 0;
    padding-left: 24px;
  }

  #content-container {
    margin: 16px 0;
    min-height: 350px;
    position: relative;
    color: #022136;
    text-align: center;
    h5 {
      font-weight: 700;
    }
    img {
      display: block;
      margin: 0 auto;
      width: 60%;
    }
  }
  ${SIZES.mobile} {
    .modal-content {
      width: 100%;
      border-radius: 0px;
    }
    #banner {
      display: block;
      margin: 0;
      width: 100%;
    }
    .modal-header {
      padding: 0;
      .close {
        position: absolute;
        right: 15px;
        top: 15px;
      }
    }
    #content-container {
      img {
        width: 90%;
      }
    }
  }
`

export default function CPDModal({ showModal, hideModal }) {
  return (
    <StyledModal backdrop={false} show={showModal} onHide={hideModal} aria-labelledby="game-modal" size="lg" centered>
      <Modal.Header closeButton>
        <img id="banner" src={HeaderBanner} alt="MMA logo banner" />
      </Modal.Header>
      <Modal.Body>
        <section id="content-container">
          <h5>Scan the QR code for CPD points</h5>
          <img src={QR} alt="QR code" />
        </section>
      </Modal.Body>
    </StyledModal>
  )
}
